import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const CommerceQuickCheckoutMicrosoftIcon = Atom.createRender(
  ({attributes, classes, generateAttributes}) => (
    <svg
      {...generateAttributes(attributes, classes)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#F05022" points="7 7 1 7 1 1 7 1" />
        <polygon fill="#7DB902" points="15 7 9 7 9 1 15 1" />
        <polygon fill="#00A4EE" points="7 15 1 15 1 9 7 9" />
        <polygon fill="#FFB700" points="15 15 9 15 9 9 15 9" />
      </g>
    </svg>
  )
);

const config = createIntegratedAtom({
  displayName: 'Icon',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Star')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'block',
          marginRight: px(8),
        },
      },
    },
  },
  render: CommerceQuickCheckoutMicrosoftIcon,
  fields: {},
});

export default config;
